import Image from "next/image";
import Container from "~/componentsDS/Layout/Container";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import Pill from "./Pill";
import { heroMedia, heroPills } from "./data";

const WhyWe = () => {
    return (
        <section className="relative -mb-4 md:-mb-6 h-dvh rounded-b-2xl md:rounded-b-3xl overflow-hidden z-[10]">
            <div className="absolute inset-0 min-h-[847px] md:min-h-[1080px]">
                <Image
                    src={heroMedia.heroBackgroundMobile}
                    alt=""
                    fill
                    priority
                    sizes="(max-width: 767px) 100vw, 0px"
                    quality={95}
                    className="object-cover object-center md:hidden"
                />
                <Image
                    src={heroMedia.heroBackground}
                    alt=""
                    fill
                    priority
                    sizes="(max-width: 767px) 0px, 100vw"
                    quality={95}
                    className="object-cover object-center max-md:hidden"
                />
            </div>

            <Container className="relative z-[1] flex justify-center h-full max-md:px-5">
                {heroPills.map((pill) => (
                    <Pill
                        key={pill.text}
                        text={pill.text}
                        className={pill.className}
                    />
                ))}

                <div className="mt-[102px] md:mt-[148px] max-w-[530px] text-center">
                    <Heading
                        as="h1"
                        weight="300"
                        size="sm"
                        sizes={{ md: "md" }}
                        className="max-[399px]:text-[30px] mb-4 md:mb-6"
                    >
                        For too long, <br className="md:hidden" />women have been <br className="max-md:hidden" />
                        <Heading
                            as="i"
                            weight="400"
                            font="featureDisplay"
                            className="max-[399px]:text-[26px] text-[28px] md:text-[36px]"
                        >
                            dismissed, misdiagnosed,
                        </Heading>{" "}
                        and told <br className="max-md:hidden" />
                        their symptoms are &ldquo;normal.&rdquo;
                    </Heading>

                    <Paragraph size="lg" sizes={{ md: "xl" }}>
                        We&apos;re here to change that with care that actually listens, looks deeper, and treats the root cause, not just the symptom.
                    </Paragraph>
                </div>
            </Container>
        </section>
    );
};

export default WhyWe;
